import { createFileRoute, Link } from "@tanstack/react-router";
import { H2, LegalLayout, List } from "../components/legal-layout";
import { provider } from "../legal/provider";

export const Route = createFileRoute("/nutzungsbedingungen")({ component: Nutzungsbedingungen });

function Nutzungsbedingungen() {
  return (
    <LegalLayout title="Nutzungsbedingungen">
      <H2>§ 1 Geltungsbereich</H2>
      <p>
        Diese Bedingungen gelten für die Nutzung von archinventory (Web-App und Android-App), einem
        Angebot von {provider.name} („Anbieter“), durch Architekturbüros und andere Unternehmen
        („Kunde“) sowie die vom Kunden eingeladenen Personen („Nutzer“). archinventory richtet sich
        ausschließlich an Unternehmer im Sinne von § 14 BGB. Abweichende Bedingungen des Kunden
        gelten nur, wenn der Anbieter ihnen schriftlich zustimmt.
      </p>

      <H2>§ 2 Vertragsschluss und Zugang</H2>
      <p>
        Der Zugang ist nur auf Einladung möglich. Der Vertrag kommt zustande, wenn der Anbieter für
        den Kunden ein Büro einrichtet und der Kunde die Einladung annimmt, oder durch eine
        gesonderte Vereinbarung. Der Kunde lädt seine Nutzer selbst ein und verwaltet deren Rollen.
      </p>

      <H2>§ 3 Leistungen</H2>
      <List>
        <li>
          archinventory ermöglicht es, Möbel und andere Inventargegenstände mit Fotos zu erfassen,
          nach Kunden, Projekten und Räumen zu ordnen, gemeinsam zu bearbeiten und als ZIP-Datei
          (Excel-Liste und Fotos) zu exportieren.
        </li>
        <li>
          Die App benötigt eine Internetverbindung. Fotos werden hochgeladen, sobald eine Verbindung
          besteht.
        </li>
        <li>
          Soweit aktiviert, schlägt eine automatische Bildauswertung (KI) Feldwerte vor. Diese
          Vorschläge können fehlerhaft sein und sind vom Kunden zu prüfen; der Anbieter übernimmt
          keine Gewähr für ihre Richtigkeit.
        </li>
        <li>
          Der Anbieter entwickelt archinventory weiter und darf Funktionen ändern, soweit der
          vertragsgemäße Zweck dadurch nicht wesentlich beeinträchtigt wird.
        </li>
      </List>

      <H2>§ 4 Verfügbarkeit</H2>
      <p>
        Der Anbieter bemüht sich um eine hohe Verfügbarkeit, schuldet aber keine bestimmte
        Verfügbarkeit, sofern nichts anderes vereinbart ist. Wartungsarbeiten werden nach
        Möglichkeit außerhalb üblicher Arbeitszeiten durchgeführt.
      </p>

      <H2>§ 5 Pflichten des Kunden</H2>
      <List>
        <li>
          Zugangsdaten sind geheim zu halten. Der Kunde sorgt dafür, dass nur berechtigte Personen
          Zugang erhalten, und entfernt Nutzer, die keinen Zugang mehr haben sollen.
        </li>
        <li>
          Der Kunde stellt sicher, dass er die erfassten Inhalte rechtmäßig verarbeiten darf. Fotos
          sollen keine Personen, Bildschirminhalte, Whiteboards oder andere vertrauliche
          Informationen zeigen; solche Aufnahmen hat der Kunde zu vermeiden oder zu löschen.
        </li>
        <li>Exportierte Dateien liegen nach dem Herunterladen in der Verantwortung des Kunden.</li>
        <li>
          Der Kunde nutzt archinventory nicht missbräuchlich, insbesondere nicht zur Überlastung
          oder zum Umgehen von Sicherheitsmaßnahmen.
        </li>
      </List>

      <H2>§ 6 Rechte an Inhalten</H2>
      <p>
        Alle vom Kunden erfassten Inhalte bleiben beim Kunden. Der Anbieter nutzt sie nur, um die
        Leistungen zu erbringen. Der Kunde kann seine Inhalte jederzeit exportieren.
      </p>

      <H2>§ 7 Vergütung</H2>
      <p>
        [Preise, Abrechnungszeitraum und Zahlungsweise ergänzen, oder: „Während der Pilotphase ist
        die Nutzung kostenlos. Über eine spätere Vergütung informiert der Anbieter rechtzeitig; sie
        gilt nur nach Zustimmung des Kunden.“]
      </p>

      <H2>§ 8 Datenschutz</H2>
      <p>
        Soweit der Anbieter personenbezogene Daten im Auftrag des Kunden verarbeitet, schließen die
        Parteien einen Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO. Im Übrigen gilt die{" "}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>

      <H2>§ 9 Haftung</H2>
      <List>
        <li>
          Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von
          Leben, Körper oder Gesundheit, nach dem Produkthaftungsgesetz sowie im Umfang einer
          übernommenen Garantie.
        </li>
        <li>
          Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung einer wesentlichen
          Vertragspflicht, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt
          erst ermöglicht und auf deren Einhaltung der Kunde regelmäßig vertrauen darf, und zwar
          begrenzt auf den vertragstypischen, vorhersehbaren Schaden.
        </li>
        <li>
          Für den Verlust von Daten haftet der Anbieter nur in dem Umfang, der auch bei regelmäßiger
          Datensicherung durch Export entstanden wäre.
        </li>
        <li>Im Übrigen ist die Haftung ausgeschlossen.</li>
      </List>

      <H2>§ 10 Laufzeit und Kündigung</H2>
      <p>
        [Laufzeit und Kündigungsfrist ergänzen, z. B.: „Der Vertrag läuft auf unbestimmte Zeit und
        kann von beiden Seiten mit einer Frist von einem Monat zum Monatsende in Textform gekündigt
        werden.“] Das Recht zur außerordentlichen Kündigung bleibt unberührt. Nach Vertragsende kann
        der Kunde seine Inhalte innerhalb von 30 Tagen exportieren; danach werden sie gelöscht,
        soweit keine gesetzlichen Aufbewahrungspflichten bestehen.
      </p>

      <H2>§ 11 Änderungen dieser Bedingungen</H2>
      <p>
        Der Anbieter kann diese Bedingungen mit Wirkung für die Zukunft ändern. Änderungen werden
        dem Kunden mindestens vier Wochen vor Inkrafttreten in Textform mitgeteilt. Widerspricht der
        Kunde nicht innerhalb dieser Frist, gelten die Änderungen als angenommen; auf diese Folge
        wird in der Mitteilung hingewiesen. Bei Widerspruch kann jede Partei den Vertrag zum
        Inkrafttreten der Änderung kündigen.
      </p>

      <H2>§ 12 Schlussbestimmungen</H2>
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
        Gerichtsstand für alle Streitigkeiten mit Kaufleuten, juristischen Personen des öffentlichen
        Rechts und öffentlich-rechtlichen Sondervermögen ist {provider.courtCity}. Sollte eine
        Bestimmung unwirksam sein, bleibt der Vertrag im Übrigen wirksam.
      </p>
    </LegalLayout>
  );
}
